import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';
import { CHANGE_BOOKING_ROOM_TYPE } from 'graphql/service';
import { reloadTrips } from 'states/CommonStates/atoms';

type ChangeOneBookingPayload = {
  bookings: Array<{
    bookingId: string;
    newRoomTypeId: string;
  }>;
};

type ChangeGroupPayload = {
  groupId: string;
  newRoomTypeId: string;
};

type ChangeBookingRoomTypeInput = ChangeOneBookingPayload | ChangeGroupPayload;

export const useChangeBookingRoomType = () => {
  const setReloadTrips = useSetRecoilState(reloadTrips);

  const [mutate, { loading, error }] = useMutation(CHANGE_BOOKING_ROOM_TYPE);

  const changeRoomType = async (input: ChangeBookingRoomTypeInput) => {
    await mutate({
      variables: { input },
    });

    // Force hard reload of trips after mutation (reloadTrips is boolean atom)
    setReloadTrips(prev => !prev);
  };

  return {
    changeRoomType,
    loading,
    error,
  };
};